import React, { PureComponent } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../components/Header';
import Liquidate from './components/Liquidate';

class LiquidateContainer extends PureComponent {
  render() {
    const { location } = this.props;

    return (
      <React.Fragment>
        <Header />
        <Container fluid className="dap_no-padding">
          <Liquidate id={location.id} />
        </Container>
      </React.Fragment>
    );
  }
}

export default LiquidateContainer;
